import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_29.module.css";
import Head from "next/head";

import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter29.json";

function Chapter_29() {
  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>EVIDENCING OF ARCHETYPES | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XXX"
        ></meta>
        <meta
          property="og:title"
          content="EVIDENCING OF ARCHETYPES | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="An abstract depiction of universal archetypes emerging from a cosmic background, symbolizing the deep-seated patterns of human consciousness. The image portrays the connection between these archetypes and the collective unconscious, highlighting their influence on individual and collective behavior."></meta>
        <meta
          property="og:description"
          content="Explore the Central Doctrine on the Evidencing of Archetypes, where ancient symbols and universal patterns reveal the hidden forces shaping human consciousness. Discover how these timeless archetypes influence personal and collective behavior, bridging the gap between the spiritual and psychological realms."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=29"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="An abstract depiction of universal archetypes emerging from a cosmic background, symbolizing the deep-seated patterns of human consciousness. The image portrays the connection between these archetypes and the collective unconscious, highlighting their influence on individual and collective behavior."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=29"></meta>
        <meta name="twitter:title" content="EVIDENCING OF ARCHETYPES | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Explore the Central Doctrine on the Evidencing of Archetypes, where ancient symbols and universal patterns reveal the hidden forces shaping human consciousness. Discover how these timeless archetypes influence personal and collective behavior, bridging the gap between the spiritual and psychological realms."></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=29" />
      </Head>


      <Common_html BlockData={BlockData} />
    </>
  );
}

export default Chapter_29;
